// @flow
import { authenticatedFetch } from '../../api/request';

export default async function cancelSubscription(orgId: number) {
    return await authenticatedFetch(`/v5/orgs/${orgId}/subscriptions`, {
        method: 'DELETE'
    });
}
